import { render, staticRenderFns } from "./PettyCashBudgetFormBox.vue?vue&type=template&id=2458dec4&scoped=true"
import script from "./PettyCashBudgetFormBox.vue?vue&type=script&lang=js"
export * from "./PettyCashBudgetFormBox.vue?vue&type=script&lang=js"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458dec4",
  null
  
)

export default component.exports